// extracted by mini-css-extract-plugin
export default {"Education":"Education_Education__6ovRl","timeline":"Education_timeline__Fb-Z4"};